export default __webpack_public_path__ + "static/media/UploadMultipleLogs.abc55b60.md";